import React from 'react';
import { Box, Container } from '@mui/material';
import ThankYou from '../components/ThankYouForPurchaseSection';
import WhatToExpect from '../components/WhatToExpect';
import ProofSecond from '../components/ProofSecond';
import Footer from '../components/Footer';

const ThankYouPage = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
            <Container maxWidth="lg" >
                <ThankYou />
                <WhatToExpect />
                <ProofSecond />
            </Container>
        </Box>
    );
};

export default ThankYouPage;